const cookieBox = document.querySelector("#cookieBox");
if (cookieBox) {
  const checkboxes = cookieBox.querySelectorAll('input[type=checkbox]:not(:disabled)');
  const cookieBoxModal = new bootstrap.Modal(cookieBox, {
    backdrop: false,
    keyboard: false
  });
  const cookieBoxLive = cookieBox.querySelector('#cookieBoxLive');
  const langCode = (document.documentElement.lang || '').toLowerCase();
  const onText = langCode.startsWith('da') ? 'til' : 'on';
  const offText = langCode.startsWith('da') ? 'fra' : 'off';

  // Get argument to not show cookiebox on "Cookies policy" page
  const URLSearch = new URLSearchParams(window.location.search);
  if (URLSearch.get('ignoreCookieBox') !== '1') {
    cookieBoxModal.show();
  }
  const announce = text => {
    if (!cookieBoxLive) return;
    cookieBoxLive.textContent = '';
    window.requestAnimationFrame(() => {
      cookieBoxLive.textContent = text;
    });
  };
  const updateSecondaryBtn = () => {
    let updateConsent = false;
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        updateConsent = true;
      }
    });
    document.querySelector("#secondaryBtn").querySelectorAll('span').forEach(span => span.classList.add('d-none'));
    if (updateConsent) {
      document.querySelector("#updateConsent").classList.remove('d-none');
    } else {
      document.querySelector("#onlyNecessary").classList.remove('d-none');
    }
  };
  checkboxes.forEach(checkbox => {
    const slider = checkbox.nextElementSibling;
    if (slider) {
      slider.setAttribute('aria-checked', checkbox.checked ? 'true' : 'false');
    }
    checkbox.addEventListener('change', () => {
      if (slider) {
        slider.setAttribute('aria-checked', checkbox.checked ? 'true' : 'false');
      }
      updateSecondaryBtn();
    });
    if (slider) {
      const toggleSwitch = () => {
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', {
          bubbles: true
        }));
        const toggleLabel = slider.closest('.col-6')?.querySelector('.mb-2')?.textContent?.trim() || slider.getAttribute('aria-label') || '';
        announce(`${toggleLabel}: ${checkbox.checked ? onText : offText}`);
      };
      slider.addEventListener('click', e => {
        e.preventDefault();
        toggleSwitch();
      });
      slider.addEventListener('keydown', e => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          toggleSwitch();
        }
      });
    }
  });
  updateSecondaryBtn();
  const cookieExtraInfoBtn = document.querySelector("#cookieExtraInfoBtn");
  const cookieExtraInfo = document.querySelector("#cookieExtraInfo");
  const syncDetailsToggle = () => {
    const isOpen = cookieExtraInfo.classList.contains('show');
    const spans = cookieExtraInfoBtn.querySelectorAll('span');
    cookieExtraInfoBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (spans[0]) spans[0].classList.toggle('d-none', isOpen);
    if (spans[1]) spans[1].classList.toggle('d-none', !isOpen);
  };
  cookieExtraInfoBtn.addEventListener('click', () => {
    setTimeout(syncDetailsToggle, 0);
  });
  cookieExtraInfoBtn.addEventListener('keydown', e => {
    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      cookieExtraInfoBtn.click();
    }
  });
  syncDetailsToggle();
}
const changeCookieLinks = document.querySelectorAll('.changeCookie');
changeCookieLinks.forEach(changeCookieLink => {
  const handler = e => {
    e.preventDefault();
    fetch("/global/ajaxHandlerGlobal.php?handler=changeCookie").then(response => response.json()).then(response => {
      if (!response.error) {
        location.reload();
      }
    });
  };
  changeCookieLink.addEventListener('click', handler);
  changeCookieLink.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      // Spacebar for ældre browser support
      handler(e);
    }
  });
});